import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getPAGAA000, getPAGAC020 } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import { MENU_DENTAL_PLUS } from '../../../shared/constants/app';
import { shouldDisplayMenu, updateMenuVisibility } from '../../../utils';

const PAGAC020 = () => {
    const [data, setData] = useState([]);
    const location = useLocation();
    const seq = location.state?.seq;
    const gubun = location.state?.gubun;
    const textGubun = location.state?.textGubun;
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);
    const [dataMenu, setDataMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
                setDataMenu(data);
            })
            .catch((error) => console.log(error));
    }, []);

    const getListData = async (seq) => {
        getPAGAC020(seq)
            .then(({ data }) => {
                setData(data);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        if (seq) {
            getListData(seq);
        }
    }, [seq]);

    return (
        <div id="content">
            <Nav menu={dentalPlusMenu} />
            <div id="tableVolunteer">
                <h3 className="vln__tit">덴탈 매거진</h3>
                <div className="vln-mbl">
                    <div className="vln-mgzn__detail">
                        <div className="vln-mgzn__top">
                            <div className="vln-mgzn__lf">
                                <span className={`vln-mgzn__gb ${gubun}`}>{textGubun}</span>
                                <div className="vln-mgzn__tit">
                                    <h3 dangerouslySetInnerHTML={{ __html: data.title }}></h3>
                                    <p>{data.bizCompany}</p>
                                </div>
                            </div>
                            <div className="vln-mgzn__view">조회수 : {data.visitedCnt}</div>
                        </div>
                        <div className="vln-mgzn__cnt" dangerouslySetInnerHTML={{ __html: data.content }}></div>
                    </div>
                    {shouldDisplayMenu('pagac010', dataMenu) && (
                        <div className="vln-btnbx">
                            <Link to="/pagac010" className="vln-listbtn">
                                목록
                            </Link>
                        </div>
                    )}
                </div>
                {/* <Pagination pages={pages} />; */}
            </div>
        </div>
    );
};

export default PAGAC020;
